import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation"

import ReviewController from "controllers/ReviewController"
const reviewController = new ReviewController()

const BaseForm = props => {
  const submitForm = v => {
    props.submit(v)
  }
  return (
    <>
      <AvForm
        onValidSubmit={(e, v) => {
            submitForm(v)
        }}
      >
        {props.formComponent}
      </AvForm>
    </>
  )
}

export default BaseForm
